export default "__VITE_ASSET__bhBkPmnB__"